/**
 * WhatsApp share links: `api.whatsapp.com/send` with UTF‑8 `text=` (spaces as %20, not +).
 * If you see %EF%BF%BD in a URL, the source text already contained U+FFFD (mojibake) — fix templates/DB charset (utf8mb4).
 */
function isUriComponentUnreservedByte(b) {
  return (
    (b >= 0x30 && b <= 0x39) ||
    (b >= 0x41 && b <= 0x5A) ||
    (b >= 0x61 && b <= 0x7A) ||
    b === 0x2d ||
    b === 0x5f ||
    b === 0x2e ||
    b === 0x7e ||
    b === 0x21 ||
    b === 0x27 ||
    b === 0x28 ||
    b === 0x29 ||
    b === 0x2a
  );
}

export function encodeWaMeText(text) {
  const s = String(text ?? '')
    .normalize('NFC')
    .replace(/\0/g, '')
    .replace(/\uFEFF/g, '')
    .replace(/\uFFFD/g, '');
  const bytes = new TextEncoder().encode(s);
  let out = '';
  for (let i = 0; i < bytes.length; i++) {
    const b = bytes[i];
    if (isUriComponentUnreservedByte(b)) out += String.fromCharCode(b);
    else out += `%${b.toString(16).toUpperCase().padStart(2, '0')}`;
  }
  return out;
}

/** Official share URL (matches WhatsApp web “Share” links; UTF‑8 safe). */
export function buildWhatsAppSendUrl(phoneDigits, text) {
  const d = String(phoneDigits || '').replace(/\D/g, '');
  if (!d) return '';
  return `https://api.whatsapp.com/send?phone=${d}&text=${encodeWaMeText(text)}`;
}

/** @deprecated Prefer {@link buildWhatsAppSendUrl} — same encoding, wa.me host. */
export function buildWaMeUrl(phoneDigits, text) {
  const d = String(phoneDigits || '').replace(/\D/g, '');
  if (!d) return '';
  return `https://wa.me/${d}?text=${encodeWaMeText(text)}`;
}
